import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import './registerServiceWorker'

import uploader from 'vue-simple-uploader'
Vue.use(uploader)

// import { Tree,Table } from 'element-ui';
// Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 };
// Vue.use(ElTree,ElTable);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// const VueUploadComponent = require('vue-upload-component')
// Vue.component('file-upload', VueUploadComponent)

import global_ from './Global.vue'//引用文件
Vue.prototype.GLOBAL = global_//挂载到Vue实例上面



Vue.config.productionTip = false;
Vue.use(Argon);




new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
